import script from "./LoanDocumentUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoanDocumentUploader.vue?vue&type=script&setup=true&lang=ts"

import "./LoanDocumentUploader.vue?vue&type=style&index=0&id=79a7c830&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a7c830"]])

export default __exports__